import { render, staticRenderFns } from "./Trabalhos.vue?vue&type=template&id=3f784971&scoped=true&"
import script from "./Trabalhos.vue?vue&type=script&lang=js&"
export * from "./Trabalhos.vue?vue&type=script&lang=js&"
import style0 from "./Trabalhos.vue?vue&type=style&index=0&id=3f784971&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f784971",
  null
  
)

export default component.exports